import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { connect } from 'react-redux';
import { compose, branch, renderNothing } from 'recompose';


import SplitLayout from '../../../layouts/SplitLayout';


import missingTicketNumberDetails from '../graphql/missingTicketNumberDetails';
import { getSelectedMissingTicketNumberId } from '../selectors';
import TicketNumberDetails from './TicketNumberDetails';
import MissingTicketNumbersTable from './MissingTicketNumbersTable';


const propTypes = exact({
  /* eslint-disable react/no-unused-prop-types */
  id: PropTypes.string.isRequired,
  /* eslint-enable react/no-unused-prop-types */

  previousTicket: PropTypes.object.isRequired,
  nextTicket: PropTypes.object.isRequired,
  missingTicketNumbers: PropTypes.array.isRequired,
});


const MissingTicketNumberDetails = (props) => {
  const {
    previousTicket,
    nextTicket,
    missingTicketNumbers,
  } = props;

  return (
    <div>
      <SplitLayout
        leftSize={6}
        leftRender={() => { return <TicketNumberDetails title="Previous" ticketNumber={previousTicket} />; }}
        rightSize={6}
        rightRender={() => { return <TicketNumberDetails title="Next" ticketNumber={nextTicket} />; }}
      />
      <div className="panel panel-default">
        <MissingTicketNumbersTable missingTicketNumbers={missingTicketNumbers} />
      </div>
    </div>
  );
};


MissingTicketNumberDetails.propTypes = propTypes;


const mapStateToProps = (state) => {
  return {
    id: getSelectedMissingTicketNumberId(state),
  };
};


const mapDispatchToProps = {};


const withRedux = connect(mapStateToProps, mapDispatchToProps);


const withHide = branch(
  (props) => { return props.id === null; },
  renderNothing,
);


const enhance = compose(
  withRedux,
  withHide,
  missingTicketNumberDetails,
);


export default enhance(MissingTicketNumberDetails);
